import axios from "axios";
import type {
  ImagesByDateResponse,
  NotUploadedResponse,
  TeamResponse,
  UploadResponse
} from "./types";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? "/",
  timeout: 60_000
});

export const getFileUrl = (storedFilename: string) => {
  const base = import.meta.env.VITE_API_BASE_URL ?? "";
  // base 为空时，走同源；否则显式指向后端（例如 http://localhost:5000）
  if (!base) return `/files/${storedFilename}`;
  return `${base.replace(/\/$/, "")}/files/${storedFilename}`;
};

export const fetchTeamMembers = async () => {
  const { data } = await api.get<TeamResponse>("/api/team-members", {
    params: { pin: "李雪峰" }
  });
  return data.items;
};

export const uploadImages = async (
  uploader: string,
  files: File[],
  onProgress?: (progress: number) => void
) => {
  const formData = new FormData();
  formData.append("uploader", uploader);
  files.forEach((file) => formData.append("files", file));

  const { data } = await api.post<UploadResponse>("/api/uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      const percentage = Math.round((event.loaded / event.total) * 100);
      onProgress(percentage);
    }
  });
  return data;
};

export const fetchImagesByDate = async (date?: string) => {
  const { data } = await api.get<ImagesByDateResponse>("/api/images", {
    params: date ? { date } : undefined
  });
  return data;
};

export const fetchNotUploadedStats = async (date?: string) => {
  const { data } = await api.get<NotUploadedResponse>(
    "/api/stats/not-uploaded",
    {
      params: date ? { date } : undefined
    }
  );
  return data;
};

export const clearUserImages = async (uploader: string, date: string) => {
  const { data } = await api.post<{ removed: number }>("/api/images/clear", {
    uploader,
    date
  });
  return data;
};

export const clearAllImages = async (password: string) => {
  const { data } = await api.post<{ removed: number }>(
    "/api/admin/clear-all",
    { password }
  );
  return data;
};

export default api;

